import React, { use, useEffect, useRef, useState } from "react";
import human from "../assets/human.png";
import save from "../assets/saveicon.png";
import delte from "../assets/deleteicon.png";
import fluent from "../assets/fluentarrow.png";
import "../App.css";
import api from "../api/api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faX } from "@fortawesome/free-solid-svg-icons";
import Editmodal from "./Modals/editmodal";
import Deletemodal from "./Modals/delete";
import ReplayIcon from '@mui/icons-material/Replay';
import Retrivemodal from "./Modals/retrive";

import PicModal from "./Modals/PicModal";
import { TimePicker, Stack } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';

import TextField from '@mui/material/TextField';
import { ClockinTimeInput, ClockInTimeInput, ClockoutTimeInput,  } from "./clockout";
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import ClearClockoutModal from "./Modals/clearclockout";
const CrudTable = ({ filterby,isoldbuild,handleclearclockout,setOpen,editedRows,SavedAPI,isDecimal, setIsDecimalMode,setEditedRows,selectedRows,submitmultipletimesheets,setSelectedRows,setAlertMessage,setSeverity,setEditmodal,
   tableData,updatetimesheet,handlesplit,fetchdata,setTableData ,setMissingdatamodal,setLoader,activeFilter,errorfields,setErrorFields}) => {
  const [entriesPerPage, setEntriesPerPage] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);
  const [decimalInputs, setDecimalInputs] = useState({}); 
  const [isChecked, setISChecked] = useState(false);

const[clickeditem,setClickeditem]=useState({})
const[editalert,setEditalert]=useState(false)
  const totalEntries = tableData.length;
    const inputRef = useRef(null);
  const [deleteemodal,setDeletemodal]=useState(false)
  const totalPages = Math.ceil(totalEntries / entriesPerPage);
const [retrivemodal,setRetrivemodal]=useState(false)
const [clearClockoutModal, setClearClockoutModal] = useState(false);
const [clearClockoutId, setClearClockoutId] = useState(null);
  const [suggestions, setSuggestions] = useState([]);
  const [costs, setcosts] = useState([]);
  const [activeRowId, setActiveRowId] = useState(null);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [showcostSuggestions, setShowcostSuggestions] = useState(false);
  const location =useLocation()
  const queryParams = new URLSearchParams(location.search);
  const [ispicmodal,setIspicModal]=useState(false)
  const companyid = queryParams.get("companyid");
  const suggestionRef = useRef(null);
  const user = useSelector((state) => state.user.userDetails);
  const isProjectManager = user?.user_roles?.role === 'Project Manager';
   const [hoveredCostIndex, setHoveredCostIndex] = useState(-1);
  const [hoveredIndex, setHoveredIndex] = useState(-1); 

  const handleSelectAll = () => {
    const filteredItems = displayedData.filter(
      (item) => !(item.status === "V" && item.is_split === "N"||item.status === "V" && item.is_split === "Y")
    );
  
    if (selectedRows.length === filteredItems.length) {
      setSelectedRows([]); // Deselect all
    } else {
      setSelectedRows(filteredItems.map((item) => item.id)); // Select only valid items
    }
  };
  console.log(tableData)

  const handleRowSelect = (id) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };
  const timeStringToMinutes = (timeStr) => {
  const [hours, minutes] = timeStr.split(':').map(Number);
  return hours * 60 + minutes;
};
const canResetClockout = (clockInTime) => {
  if (!clockInTime) return false;

  const clockIn = dayjs(clockInTime);
  const now = dayjs();

  const diffHours = now.diff(clockIn, "hour");

  return diffHours <= 12; // allow reset within 16 hours
};
  useEffect(()=>{
    console.log(errorfields,'err')
  },[errorfields])
  const handleMultipleRowSelect = (ids) => {
    setSelectedRows((prev) => {
      const newSelected = [...prev];
  
      ids.forEach((id) => {
        const item = displayedData.find((data) => data.id === id);
  
        // Skip items with status "V" and is_split "N"
        if (item?.status === "V" && item?.is_split === "N"||item.status === "V" && item.is_split === "Y") {
          return;
        }
  
        const index = newSelected.indexOf(id);
        if (index > -1) {
          newSelected.splice(index, 1); // Deselect
        } else {
          newSelected.push(id); // Select
        }
      });
  
      return newSelected;
    });
  };
  // decimal → HH:MM
const decimalToHHMM = (val) => {
  if (!val) return "00:00";
  const num = parseFloat(val);
  if (isNaN(num)) return "00:00";
  const hours = Math.floor(num);
  const minutes = Math.round((num - hours) * 60);
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
};

// HH:MM → decimal (for showing in input when isDecimal = true)
const hhmmToDecimal = (val) => {
  if (!val) return "";
  const [h, m] = val.split(":").map(Number);
  if (isNaN(h) || isNaN(m)) return "";
  return (h + m / 60).toFixed(2); // two decimal places
};

// const check_is_valid_duration = (emp_id, newtime, type) => {
//   // Convert ISO string or HH:mm string to minutes from start of day
//   const timeToMinutes = (timeStr) => {
//     if (!timeStr) return 0;
//     // If timeStr is full ISO datetime, extract HH:mm
//     let timePart = timeStr.includes('T') ? timeStr.split('T')[1].substring(0, 5) : timeStr;
//     const [h, m] = timePart.split(':').map(Number);
//     return h * 60 + m;
//   };

//   // Convert "HH:mm:ss" to decimal hours (e.g. "00:50:00" => 0.8333)
//   const timeStrToHours = (timeStr) => {
//     if (!timeStr) return 0;
//     const parts = timeStr.split(':').map(Number);
//     if (parts.length !== 3) return 0;
//     const [h, m, s] = parts;
//     return h + m / 60 + s / 3600;
//   };

//   const newMinutes = timeToMinutes(newtime);

//   // Find parent record (is_split === 'N')
//   const parent = tableData.find(
//     item => item.emp_id === emp_id && item.is_split === 'N'
//   );

//   if (!parent) {
//     console.warn('Parent record not found for employee', emp_id);
//     return false;
//   }

//   // Find children records (is_split !== 'N')
//   const children = tableData.filter(
//     item => item.emp_id === emp_id && item.is_split !== 'N'
//   );

//   console.log('Children records', children);

//   // Sum total hours of children from "hours" field (HH:mm:ss)
//   const sumChildHours = children.reduce((sum, child) => {
//     return sum + timeStrToHours(child.hours);
//   }, 0);

//   console.log('Sum of children hours:', sumChildHours);

//   // Get parent's break time in minutes (assumes break_time is in hours as number or string)
//   const parentBreakMinutes = (parseFloat(parent.break_time) || 0) * 60;

//   console.log('Parent break time in minutes:', parentBreakMinutes);

//   // Calculate total required minimum difference in minutes
//   const minDiffMinutes = parentBreakMinutes + sumChildHours * 60;

//   console.log('Minimum required difference in minutes:', minDiffMinutes);

//   // For clock_in, parent.clock_out must exist; for clock_out, parent.clock_in must exist
//   if (type === 'clock_in' && !parent.clock_out) {
//     console.warn('Parent clock_out missing');
//     return false;
//   }

//   if (type === 'clock_out' && !parent.clock_in) {
//     console.warn('Parent clock_in missing');
//     return false;
//   }

//   console.log('Parent clock_in:', parent.clock_in);
//   console.log('Parent clock_out:', parent.clock_out);

//   const parentClockInMinutes = timeToMinutes(parent.clock_in);
//   const parentClockOutMinutes = timeToMinutes(parent.clock_out);

//   console.log('parentClockInMinutes:', parentClockInMinutes);
//   console.log('parentClockOutMinutes:', parentClockOutMinutes);

//   let diff;

//   if (type === 'clock_in') {
//     // new clock_in compared with parent's clock_out
//     diff = parentClockOutMinutes - newMinutes;
//   } else if (type === 'clock_out') {
//     // new clock_out compared with parent's clock_in
//     diff = newMinutes - parentClockInMinutes;
//   } else {
//     console.warn('Invalid type:', type);
//     return false;
//   }

//   console.log('Time difference:', diff);

//   // Valid if difference is >= minDiffMinutes and diff >= 0 (logical)
//   if (diff < minDiffMinutes || diff < 0) {
//     return false;
//   } else {
//     return true;
//   }
// };

const check_is_valid_duration = (obj, emp_id, newtime, type, allTimesheets = tableData) => {
  const toMinutes = (timeStr) => {
    const [hours, minutes] = timeStr.split(":").map(Number);
    return hours * 60 + minutes;
  };

  const toTimePart = (datetimeStr) => {
    if (!datetimeStr || typeof datetimeStr !== "string") {
      // If null, undefined, or not a string, return null to indicate invalid time
      return null;
    }
    if (datetimeStr.includes("T")) {
      return datetimeStr.split("T")[1].slice(0, 5); // "HH:MM"
    } else {
      return datetimeStr;
    }
  };

  console.log("Checking for emp_id:", emp_id);

  const parent = allTimesheets.find(
    (rec) => rec.emp_id === emp_id && rec.is_split === "N"
  );

  if (!parent) {
    console.log("No parent record found for employee:", emp_id);
    return false;
  }

  const updatedClockIn = type === "clock_in"
    ? newtime
    : editedRows?.[obj.id]?.["clock_in"] ?? parent.clock_in;

  const updatedClockOut = type === "clock_out"
    ? newtime
    : editedRows?.[obj.id]?.["clock_out"] ?? parent.clock_out;

  const clockInTimePart = toTimePart(updatedClockIn);
  const clockOutTimePart = toTimePart(updatedClockOut);

  // If clock_in or clock_out is null or invalid, skip validation and return true (or false if you want to mark invalid)
  if (!clockInTimePart || !clockOutTimePart) {
    console.log("Invalid or missing clock_in/clock_out time, ignoring validation.");
    return true;  // Change to false if you want to invalidate missing times
  }

  const clockInMinutes = toMinutes(clockInTimePart);
  const clockOutMinutes = toMinutes(clockOutTimePart);
  const durationMinutes = clockOutMinutes - clockInMinutes;

  console.log("Clock In:", updatedClockIn, "->", clockInMinutes, "minutes");
  console.log("Clock Out:", updatedClockOut, "->", clockOutMinutes, "minutes");
  console.log("Duration Minutes:", durationMinutes);

  if (durationMinutes <= 0) {
    console.log("Invalid time range: Duration is less than or equal to 0");
    return false;
  }

  let totalWorkedMinutes = 0;

  const children = allTimesheets.filter(
    (rec) => rec.emp_id === emp_id && rec.is_split === "Y"
  );

  console.log("Children records count:", children.length);

  for (const child of children) {
    const childMinutes = toMinutes(child.hours || "00:00");
    console.log(`Child hours: ${child.hours} -> ${childMinutes} minutes`);
    totalWorkedMinutes += childMinutes;
  }

  const breakTime = parseFloat(
    editedRows?.[obj.id]?.["break_time"] ?? parent?.break_time ?? 0
  );

  console.log("Break time (minutes):", breakTime);

  totalWorkedMinutes += breakTime;

  console.log("Total worked minutes (including break):", totalWorkedMinutes);

  const isValid = durationMinutes >= totalWorkedMinutes;
  console.log("Is duration valid?", isValid);

  return isValid;
};



  
  const displayedData = tableData.slice(
    (currentPage - 1) * entriesPerPage,
    currentPage * entriesPerPage
  );
  const fetchSuggestions = async (query,item) => {
    try {
      if (!query) {
        setSuggestions([]);
        return;
      }
if (/^0{1,4}$/.test(query)) {
  setSuggestions([{ job_num: '0000', job_name: 'Overhead' }]);
  setShowSuggestions(true);
       setErrorFields([])
} else {
  const response = await api.get(`/v1/timesheets/get-jobs`, {
    params: {
      company_id: companyid,
      job_num: query,
    },
  });

  if (response.status === 200) {
    setSuggestions(response.data || []);
    setShowSuggestions(true);
      setErrorFields([])

  }else{
     errorfields.push({ rowId: item, field:"job_id"});
        errorfields.push({ rowId: item, field:"no_job_code"});
        setSuggestions( []);
        setShowSuggestions(!true)
        // handleEdit(item, "job_id", '')
      }
}

         
    
    } catch (error) {
           errorfields.push({ rowId: item, field:"job_id"});
        errorfields.push({ rowId: item, field:"no_job_code"});
      console.error("Error fetching jobcodes:", error);
    }
  };

  const fetchcostsSuggestions = async (query,item) => {
    try {
      if (!query) {
        setcosts([]);
        return;
      }
 if (/^0{1,4}$/.test(query)) {
  setcosts([{ cost_code: '0000', costcode_name: 'Overhead' }]);
  setShowcostSuggestions(true);
     setErrorFields([])
} else {

    const response = await api.get(`/v1/timesheets/get-costcodes`, {
      params: {
        company_id: companyid,
        cost_code: query,
      },
    });

    if (response.status === 200) {
      setcosts(response.data || []);
      
      setErrorFields([])
      setShowcostSuggestions(true);
    } else {
      setcosts([]);
      errorfields.push({ rowId: item, field:"cost_code_id"});
        errorfields.push({ rowId: item, field:"no_cost_code"});
      setShowcostSuggestions(false);
      // handleEdit(item, "cost_code_id", '');
    }
    
    } }catch (error) {
        errorfields.push({ rowId: item, field:"cost_code_id"});
           errorfields.push({ rowId: item, field:"no_cost_code"});
      console.error("Error fetching jobcodes:", error);
    }
  };
  const groupBy = (data, key) => {
    return data.reduce((acc, item) => {
      const groupKey = item[key];
      if (!acc[groupKey]) {
        acc[groupKey] = [];
      }
      acc[groupKey].push(item);
      return acc;
    }, {});
  };

  const handleDelete=async()=>{
    try {
      setLoader(true)
      const response =await api.put(`/v1/timesheets/${clickeditem?.id}/DELETED`)
      // await api.put(`/v1/timesheets/${clickeditem?.id}`,{

      // })
      if(response.status==200){

      }else{

      }
    } catch (error) {
      console.log(error)
    }finally{
      setDeletemodal(false)
      fetchdata()
  setLoader(false)
    }
  }
  const handleRetrive=async()=>{
    try {
      setLoader(true)
      const response =await api.put(`/v1/timesheets/${clickeditem?.id}/PENDING`)
      if(response.status==200){

      }else{

      }
    } catch (error) {
      console.log(error)
    }finally{
      setRetrivemodal(false)
      fetchdata()
  setLoader(false)
    }
  }

// const getparent = (item, raw) => {
//   console.log('Function called with:', { item, raw });

//   // Validate input format
//   if (!item.hours || !raw || !item.hours.includes(':') || !raw.includes(':')) {
//     console.warn('Invalid format for item.hours or raw');
//     return false;
//   }

//   // Convert item.hours and raw to total minutes
//   const [itemH, itemM] = item.hours.split(':');
//   const [rawH, rawM] = raw.split(':');

//   const itemMinutes = parseInt(itemH) * 60 + parseInt(itemM);
//   const rawMinutes = parseInt(rawH) * 60 + parseInt(rawM);

//   console.log('Converted times => itemMinutes:', itemMinutes, ', rawMinutes:', rawMinutes);

//   if (isNaN(itemMinutes) || isNaN(rawMinutes)) {
//     console.warn('Invalid numeric values for time');
//     return false;
//   }

//   // If raw is less than or equal to item.hours, no need to subtract from parent
//   if (rawMinutes <= itemMinutes) {
//     console.log('No subtraction needed, rawMinutes <= itemMinutes');
//     return true;
//   }

//   // Calculate the extra minutes needed
//   const extraMinutes = rawMinutes - itemMinutes;
//   console.log('Extra minutes needed:', extraMinutes);

//   // Find parent
//   const parent = tableData.find(
//     obj => obj.emp_id === item.emp_id && obj.is_split === 'N'
//   );

//   console.log('Found parent:', parent);

//   if (!parent || !parent.hours || !parent.hours.includes(':')) {
//     console.warn('No valid parent found or invalid parent hours');
//     return false;
//   }

//   const [parentH, parentM] = parent.hours.split(':');
//   const parentMinutes = parseInt(parentH) * 60 + parseInt(parentM);

//   console.log('Parent total minutes:', parentMinutes);

//   if (isNaN(parentMinutes)) {
//     console.warn('Invalid parent time');
//     return false;
//   }

//   // Check if parent has enough time
//   if (extraMinutes > parentMinutes) {
//     console.warn('Not enough time in parent to cover excess');
//     return false;
//   }

//   // Subtract extra minutes from parent
//   const newParentMinutes = parentMinutes - extraMinutes;
//   const newH = String(Math.floor(newParentMinutes / 60)).padStart(2, '0');
//   const newM = String(newParentMinutes % 60).padStart(2, '0');
//   const newTime = `${newH}:${newM}`;

//   console.log('New time to update in parent:', newTime);

//   // Update parent's time
//   handleEdit(parent.id, 'hours', newTime);
//   console.log('Updated parent hours successfully.');

//   return true;
// };

const getparent = (item, raw) => {
  console.log('Function called with:', { item, raw });

  if (!item.hours || !raw || !item.hours.includes(':') || !raw.includes(':')) {
    console.warn('Invalid format for item.hours or raw');
    return false;
  }

  const [itemH, itemM] = item.hours.split(':');
  const [rawH, rawM] = raw.split(':');

  const itemMinutes = parseInt(itemH) * 60 + parseInt(itemM);
  const rawMinutes = parseInt(rawH) * 60 + parseInt(rawM);

  if (isNaN(itemMinutes) || isNaN(rawMinutes)) {
    console.warn('Invalid numeric values for time');
    return false;
  }

  if (rawMinutes === itemMinutes) {
    console.log('No change needed, rawMinutes === itemMinutes');
    return true;
  }

  const diffMinutes = Math.abs(rawMinutes - itemMinutes);
  const parent = tableData.find(obj => obj.emp_id === item.emp_id && obj.is_split === 'N');

  if (!parent || !parent.hours || !parent.hours.includes(':')) {
    console.warn('No valid parent found or invalid parent hours');
    return false;
  }

  const [parentH, parentM] = parent.hours.split(':');
  const parentMinutes = parseInt(parentH) * 60 + parseInt(parentM);

  if (isNaN(parentMinutes)) {
    console.warn('Invalid parent time');
    return false;
  }

  let newParentMinutes;

  if (rawMinutes > itemMinutes) {
    // Take time from parent
    if (diffMinutes > parentMinutes) {
      console.warn('Not enough time in parent to cover excess');
      return false;
    }
    newParentMinutes = parentMinutes - diffMinutes;
    console.log('Subtracting from parent:', diffMinutes);
  } else {
    // Add time back to parent
    newParentMinutes = parentMinutes + diffMinutes;
    console.log('Adding back to parent:', diffMinutes);
  }

  const newH = String(Math.floor(newParentMinutes / 60)).padStart(2, '0');
  const newM = String(newParentMinutes % 60).padStart(2, '0');
  const newTime = `${newH}:${newM}`;

  console.log('Updated parent time:', newTime);
  handleEdit(parent.id, 'hours', newTime);

  return true;
};
const getparent2 = (item, raw) => {
  console.log('Function called with:', { item, raw });

  if (!item.hours || !raw || !item.hours.includes(':') || !raw.includes(':')) {
    console.warn('Invalid format for item.hours or raw');
    return false;
  }

  const [itemH, itemM] = item.hours.split(':');
  const [rawH, rawM] = raw.split(':');

  const itemMinutes = parseInt(itemH) * 60 + parseInt(itemM);
  const rawMinutes = parseInt(rawH) * 60 + parseInt(rawM);

  if (isNaN(itemMinutes) || isNaN(rawMinutes)) {
    console.warn('Invalid numeric values for time');
    return false;
  }

  if (rawMinutes === itemMinutes) {
    console.log('No change needed, rawMinutes === itemMinutes');
    return true;
  }

  const diffMinutes = Math.abs(rawMinutes - itemMinutes);
  const parent = tableData.find(obj => obj.emp_id === item.emp_id && obj.is_split === 'N');

  if (!parent || !parent.hours || !parent.hours.includes(':')) {
    console.warn('No valid parent found or invalid parent hours');
    return false;
  }

  const [parentH, parentM] = parent.hours.split(':');
  const parentMinutes = parseInt(parentH) * 60 + parseInt(parentM);

  if (isNaN(parentMinutes)) {
    console.warn('Invalid parent time');
    return false;
  }

  let newParentMinutes;

  if (rawMinutes > itemMinutes) {
    // Take time from parent
    if (diffMinutes > parentMinutes) {
      console.warn('Not enough time in parent to cover excess');
      return false;
    }
    newParentMinutes = parentMinutes - diffMinutes;
    console.log('Subtracting from parent:', diffMinutes);
  } else {
    // Add time back to parent
    newParentMinutes = parentMinutes + diffMinutes;
    console.log('Adding back to parent:', diffMinutes);
  }

  const newH = String(Math.floor(newParentMinutes / 60)).padStart(2, '0');
  const newM = String(newParentMinutes % 60).padStart(2, '0');
  const newTime = `${newH}:${newM}`;

  console.log('Updated parent time:', newTime);
  handleEdit(parent.id, 'hours', newTime);

  return true;
};
function isValidClockTime(item, newvalue, type) {
  // Helper: check if date string is valid ISO datetime
  function isValidISODate(dateStr) {
    return typeof dateStr === 'string' && !isNaN(Date.parse(dateStr));
  }

  // Validate clock_in and clock_out first
  if (!isValidISODate(item.clock_in) || !isValidISODate(item.clock_out)) {
    // Ignore validation if either date is missing or invalid
    return true;
  }

  // Extract date parts (YYYY-MM-DD)
  const clockInDate = item.clock_in.split('T')[0];
  const clockOutDate = item.clock_out.split('T')[0];

  // Extract time parts (HH:mm:ss)
  const clockInTime =editedRows?.[item.id]?.["clock_in"]?? item.clock_in.split('T')[1].slice(0, 8);
  const clockOutTime = editedRows?.[item.id]?.["clock_out"]??item.clock_out.split('T')[1].slice(0, 8);

  // Normalize newvalue to HH:mm:ss
  let newTime = newvalue.length === 5 ? newvalue + ':00' : newvalue;

  if (clockInDate === clockOutDate) {
    if (type === 'clock_out') {
      // new clock_out must be after clock_in
      return newTime > clockInTime;
    } else if (type === 'clock_in') {
      // new clock_in must be before clock_out
      return newTime < clockOutTime;
    }
  }

  // If dates are different, no restriction
  return true;
}



  
const calculateHours = (clockIn, clockOut, breakMinutes = 0, item) => {
  if (!clockIn || !clockOut) {
    console.log('Missing clockIn or clockOut:', { clockIn, clockOut });
    return "00:00";
  }

const parseTime = (timeStr, baseDate = new Date()) => {
  if (timeStr.includes("T")) {
    const date = new Date(timeStr);
        console.log('Parsed ISO datetime:', date.toString());
    if (isNaN(date)) return null;

    // Remove seconds and milliseconds
    date.setSeconds(0, 0);
    return date;
  } else {
    const [h, m] = timeStr.split(":").map(Number);
    if (isNaN(h) || isNaN(m)) return null;

    const date = new Date(baseDate);
        console.log(`Parsed non-ISO time: ${timeStr} →`, date.toString());
    date.setHours(h, m, 0, 0); // already sets seconds to 0
    return date;
  }
};
console.log('Raw clockIn:', clockIn);
console.log('Raw clockOut:', clockOut);


  // const baseDate = clockIn.includes("T")
  //   ? new Date(clockIn)
  //   : new Date();
  let baseDate;

if (item?.clock_in?.includes("T")) {
  baseDate = new Date(item.clock_in);
} else if (item?.clock_out?.includes("T")) {
  baseDate = new Date(item.clock_out);
} else if (clockIn?.includes("T")) {
  baseDate = new Date(clockIn);
} else {
  baseDate = new Date();
}
console.log('Base date (used for both):', baseDate.toString());
  const start = parseTime(clockIn, baseDate);
  const end = parseTime(clockOut, baseDate);

  if (!start || !end) {
    console.log('Failed to parse times');
    return "00:00";
  }
console.log("Parsed start time:", start);
console.log("Parsed end time:", end);
  let diffInMs = end - start;

  if (diffInMs < 0) {
    console.log('Overnight shift detected');
    diffInMs += 24 * 60 * 60 * 1000;
  }

  let totalMinutes = Math.floor(diffInMs / (1000 * 60));
  console.log('Initial totalMinutes (before break):', totalMinutes);

  totalMinutes = Math.max(totalMinutes - breakMinutes, 0);
  console.log('TotalMinutes after subtracting break:', totalMinutes);

  let mappedTotalMinutes = 0;
  if (tableData && Array.isArray(tableData)) {
    console.log('Checking split hours to subtract for emp_id:', item.emp_id);
    tableData.forEach(mappedItem => {
      if (mappedItem.emp_id === item.emp_id && mappedItem.is_split === 'Y') {
        console.log('Found split item:', mappedItem);
        const [h = 0, m = 0] = mappedItem.hours.split(":").map(Number);
        if (!isNaN(h) && !isNaN(m)) {
          const extraMinutes = h * 60 + m;
          mappedTotalMinutes += extraMinutes;
          console.log(`Subtracting ${extraMinutes} mins from hours: ${mappedItem.hours}`);
        }
      }
    });
  }

  totalMinutes = Math.max(totalMinutes - mappedTotalMinutes, 0);
  console.log('Final totalMinutes after subtracting split items:', totalMinutes);

  const finalHours = Math.floor(totalMinutes / 60);
  const finalMinutes = totalMinutes % 60;

  const formatted = `${String(finalHours).padStart(2, '0')}:${String(finalMinutes).padStart(2, '0')}`;
  console.log('Final calculated time:', formatted);

  return formatted;
};







  
  const handleSelect = (selectedCode) => {
  
    setSuggestions([]);
    setShowSuggestions(false);
  }
  const handleEdit = (id, field, value) => {

    setEditedRows((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        [field]: value,
      },
    }));
  };

  const statusEdit = (id, key, value) => {
    setTableData(prevData =>
      prevData.map(item =>
        item.id === id ? { ...item, [key]: value } : item
      )
    );
  };
  const allowedit=async()=>{
    setEditalert(false)
try {
 await api.put(`v1/timesheets/${clickeditem?.id}/PENDING`)
} catch (error) {
  
}finally{
fetchdata(true)
}
return

    if(clickeditem.is_split==='Y'&&clickeditem.status=='V'){
      statusEdit(clickeditem.id, "status", 'edit');
      statusEdit(clickeditem.id, "is_split", 'Y')
return
     }
         statusEdit(clickeditem.id, "status", 'P');
         statusEdit(clickeditem.id, "is_split", 'N');
  }

  const submitmultiple = () => {
    const matchedRows = tableData.filter(row => selectedRows.includes(row.id));  
    const requiredKeys = ['job_id', 'cost_code_id', 'clock_in', 'clock_out', 'break_time', 'perdim'];
    let isValid = true;
    let needsSave = false;
  
    for (const row of matchedRows) {
      const shouldSkipTimeFields = (
        (row.status === 'S' && row.is_split === 'Y') ||
        (row.status === 'P' && row.is_split === 'Y') ||(row.status === 'D' && row.is_split === 'Y') ||
        (row.status === 'A' && row.is_split === 'Y')||row.etype=='EQP'
      );
  
      for (const key of requiredKeys) {
        if (shouldSkipTimeFields && ['clock_in', 'clock_out', 'break_time','perdim'].includes(key)) {
          continue;
        }
  
        const rowValue = row[key];
        const isMissing = rowValue === undefined || rowValue === null || rowValue === '';
  
        // Row has missing required field
        if (isMissing) {
          const editedValue = editedRows?.[row.id]?.[key];
  
          if (editedValue !== undefined && editedValue !== null && editedValue !== '') {
            // Value is edited but not saved
            console.log(`Row ID ${row.id} has unsaved edited value for key: ${key}`);
            needsSave = true;
          } else {
            // Value is missing and not edited
            console.log(`Row ID ${row.id} is missing required field: ${key}`);
            isValid = false;
          }
  
          break; // stop further checks on this row
        }
      }
  
      if (!isValid || needsSave) break;
    }
  
    if (isValid && !needsSave) {
      submitmultipletimesheets();
    } else if (needsSave) {
      setSeverity("warning");
      setAlertMessage("Please save edited rows before submitting.");
      setOpen(true);
    } else {
      setSeverity("error");
      setAlertMessage("Required fields are missing.");
      setOpen(true);
    }
  };
  
 const Savedmultiple = () => {
      SavedAPI();
  };
  
  
  const handleSave = (id = null, obj) => {
    const requiredKeys = ['job_id', 'cost_code_id', 'clock_in', 'clock_out', 'break_time', 'perdim'];
    const tempErrorFields = [];
    console.log(errorfields,'eror')
const hasNoCostCodeError = errorfields.some(
  (err) => err.field === "no_cost_code" && err.rowId === id
);

const hasNoJobCodeError = errorfields.some(
  (err) => err.field === "no_job_code" && err.rowId === id
);

if (hasNoCostCodeError) {
  setSeverity("error");
  setAlertMessage("Invalid Cost Code Entered");
  setOpen(true);
  return;
}

if (hasNoJobCodeError) {
  setSeverity("error");
  setAlertMessage("Invalid Job Code Entered");
  setOpen(true);
  return;
}

    const isValidRow = (originalRow, editedRow) => {
      let isValid = true;
      for (const key of requiredKeys) {
        const value = editedRow?.[key] !== undefined ? editedRow[key] : originalRow?.[key];
    
        const shouldSkipTimeFields =
          (originalRow?.status === 'S' && originalRow?.is_split === 'Y') ||
          (originalRow?.status === 'P' && originalRow?.is_split === 'Y') ||  (originalRow?.status === 'D' && originalRow?.is_split === 'Y') ||
          (originalRow?.status === 'A' && originalRow?.is_split === 'Y') ||
          originalRow?.etype === 'EQP';
    
        if (shouldSkipTimeFields && ['clock_in', 'clock_out', 'break_time','perdim'].includes(key)) continue;
        if (['break_time'].includes(key)) continue;
    
        if (key === 'perdim' || key === 'cost_code_id' || key === 'job_id') {
          
          const valid = value !== null && value !== '';
          if (!valid) {
            console.log(`Field '${key}' is missing or null.`);
            tempErrorFields.push({ rowId: originalRow.id, field: key });
            isValid = false;
          }
          continue;
        }
    
        const valid = value !== null && value !== 0 && value !== '0';
        if (!valid) {
          console.log(`Field '${key}' is missing or has an invalid value: ${value}`);
          tempErrorFields.push({ rowId: originalRow.id, field: key });
          isValid = false;
        }
      }
      return isValid;
    };
    
    if (id !== null) {
      const originalRow = tableData.find((item) => item.id === id);
      const editedRow = editedRows?.[id];
      if (isValidRow(originalRow, editedRow)) {
      let dataToSend = { ...editedRow };

if (obj.is_split === 'N'&&originalRow.etype !== 'EQP') {
  if (editedRow) {
    const { hours, ...rest } = editedRow;
    dataToSend = rest;
  } else {
    return; // Or handle it appropriately
  }
}


updatetimesheet(dataToSend, Number(id));
    
      } else {

        setSeverity("error");
        setAlertMessage('Required Fields Are Missing');
        setOpen(true);
        setMissingdatamodal(true)
      }
    } else {
      Object.entries(editedRows).forEach(([rowId, changes]) => {
        const originalRow = tableData.find((item) => item.id === Number(rowId));
        if (isValidRow(originalRow, changes)) {
          let dataToSend = { ...changes };

if (obj.is_split === 'N') {
  const { hours, ...rest } = changes;
  dataToSend = rest;
}

          updatetimesheet(dataToSend, Number(rowId));
        } else {
          setSeverity("error");
          setAlertMessage('Required Fields Are Missing');

          setOpen(true);
          console.warn(`Row ${rowId} has missing required values.`);
        }
      });
    
    }
    setErrorFields(tempErrorFields);
  };
  
  ;
  const handlesplitsave = async (id) => {
    const editedRow = editedRows[id];
    
    // Check if the row is actually edited
    if (!editedRow) {
      handlesplit(id);
      return; // Do not proceed if no row is edited
    }
  
    // Validate the row to ensure required fields are not missing
    const isValid = Object.values(editedRow).every(val => val !== null && val !== undefined);
    
    if (!isValid) {
    
      handlesplit(id); 
      return; // Do not allow split if validation fails
    }
  
    // Check if conditions for allowing 'hours' key are met
    if (
      (editedRow.status === 'S' || editedRow.status === 'P' ||editedRow.status === 'D' || editedRow.status === 'A' || editedRow.status === 'V' || editedRow.status === 'edit') 
      && editedRow.is_split === 'Y'
    ) {
      // Allow hours key
      if (!editedRow.hasOwnProperty('hours')) {
        editedRow.hours = 0; // Default value if hours is not present
      }
    } else {
      // Remove hours key if it exists
      if (editedRow.hasOwnProperty('hours')) {
        delete editedRow.hours;
      }
    }
  
    // Proceed with the update if the row was edited
    const success = await updatetimesheet(editedRow, Number(id));
    
    if (success) {
       handlesplit(id); // Proceed with split if the update is successful
    } else {
      setSeverity("error");
      setAlertMessage("Parent changes were not saved");
      setOpen(true); // Show error toast even though split is allowed
      handlesplit(id); // Allow split even if update fails
    }
  };
  
  
  
  

  let groupedData = {};
  if (filterby.name === "Classification") {
    groupedData = groupBy(displayedData, "classification");
  } else if (filterby.name === "Job Code") {
    groupedData = groupBy(displayedData, "job_id");
  } else if (filterby.name === "Cost Code") {
    groupedData = groupBy(displayedData, "cost_code_id");
  } else if (filterby.name === "Employee") {
    groupedData = groupBy(displayedData, "emp_id");
  } else {
    // No grouping case, use the entire displayed data as a single group
    groupedData = { "No Grouping": displayedData };
  }

  const hasEdits = () => {
    return Object.keys(editedRows).length > 0;
  };
 

  
  const handleDeleterow = async (itemID) => {

    
  };
  const restorebulk=async()=>{
    try {
      setLoader(true)

      const response=await api.put('v1/timesheets/status-update/PENDING',{
        "timesheet_ids":selectedRows
      })
      if(response.status==200){
        setSeverity("success")
         setAlertMessage('Records Restored Succesfully')
         setOpen(true)
         setEditmodal(false)
 
         }else{
           setSeverity("info")
           setAlertMessage(response.message)
           setOpen(true)
       
         }
    } catch (error) {
      console.log(error)
      setSeverity("error")
      setAlertMessage('something went wrong')
      setOpen(true)
    }finally{
setLoader(false)
setSelectedRows([])
fetchdata(true)
    }
  }

  return (
    <div className="w-full max-w-full min-h-[80vh] overflow-x-auto custom-scrollbar">
   
      {(selectedRows?.length) && (activeFilter?.label!=='Deleted')? (
      <div className="w-full flex flex-wrap justify-between items-center py-4 gap-4">
      <div className="flex flex-wrap gap-4">
        <div
        
        onClick={() => {
         
              setEditmodal(true)
            
          }}
        className="bg-[#900] text-white min-w-[120px] px-4 py-2 cursor-pointer rounded-md transition-colors duration-200">
          Edit selected ({selectedRows.length})
        </div>
        <div
        onClick={()=>{
     
          submitmultiple()
        
        // submitmultiple()
        }}
        
        className="bg-[#900] text-white min-w-[120px] px-4 py-2 cursor-pointer rounded-md transition-colors duration-200">
          Submit selected ({selectedRows.length})
        </div>
      </div>
      <div
        onClick={()=>{
     
          Savedmultiple()
        
        // submitmultiple()
        }}
        
        className="bg-[#900] text-white min-w-[120px] px-4 py-2 cursor-pointer rounded-md transition-colors duration-200">
          Saved selected ({selectedRows.length})
        </div>
      {/* <div className="bg-[#900] text-white min-w-[120px] px-4 py-2 cursor-pointer rounded-md transition-colors duration-200">
        Save selected ({selectedRows.length})
      </div> */}
    </div>
    
      ) : (selectedRows?.length)?(
        <>
         <div
        
        onClick={() => {
         
           restorebulk()
            
          }}
        className="bg-[#900] text-white min-w-[120px]  max-w-[160px] mb-2 px-4 py-2 cursor-pointer rounded-md transition-colors duration-200">
    Restore ({selectedRows.length})
        </div>
        </>
      ):<></>}
      <table className="w-full min-w-[1000px] border-collapse mt-3">
        <thead>
          <tr className="border border-gray-300 text-[#900]">
            <th className="p-3">
              <div className="flex justify-center items-center">
             {tableData?.length?
              <input
  type="checkbox"
  checked={
    displayedData.filter(
      item =>
        !(item.status === "V" && (item.is_split === "N" || item.is_split === "Y"))
    ).length > 0 &&
    selectedRows.length ===
      displayedData.filter(
        item =>
          !(item.status === "V" && (item.is_split === "N" || item.is_split === "Y"))
      ).length
  }
 onChange={() => {
    if (isProjectManager) return; // Prevent logic
    handleSelectAll();
  }}
  className={`w-4 h-4 rounded ${
    isProjectManager ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
  } form-checkbox ${
    displayedData.filter(
      item =>
        !(item.status === "V" && (item.is_split === "N" || item.is_split === "Y"))
    ).length > 0 &&
    selectedRows.length ===
      displayedData.filter(
        item =>
          !(item.status === "V" && (item.is_split === "N" || item.is_split === "Y"))
      ).length
      ? "accent-[#900] border-[#900]"
      : "appearance-none border-2 border-[#900]"
  }`}
/>:<></>
}
              </div>
            </th>
            <th className="p-3 pl-9 w-[20%] font-inter font-normal text-start">
              Employee
            </th>
            <th className="p-3 w-[10%] font-inter font-normal text-start">
              Job Code
            </th>
            <th className="p-3 w-[10%] font-inter font-normal text-start">
              Cost Code
            </th>
            <th className="p-3 w-[10%] font-inter font-normal text-start">
              Clock In
            </th>
            <th className="p-3 w-[10%] font-inter font-normal text-start">
              Clock Out
            </th>
            <th className="p-3 w-[7%] font-inter font-normal  text-start">
              Break (mins)
            </th>
            <th className="p-3 w-[12%] font-inter font-normal text-start">
              Per Diem ($)
            </th>
            <th className="p-3 w-[7%] font-inter font-normal text-start">
              Total Hours (HH:MM)
            </th>
            <th className="p-3 pl-7 w-[20%] font-inter font-normal text-start">
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          {Object.keys(groupedData).map((groupKey) =>
           (
            <React.Fragment key={groupKey}>
              {filterby.name !== "No Grouping" && (
           <tr>
           <td
             colSpan={10}
             className="bg-[#FEE2E2] font-inter font-normal text-start text-[#900] p-3"
           >
             <div className="flex items-center gap-2">
     <input
  type="checkbox"
  onChange={() =>
    handleMultipleRowSelect(
      groupedData[groupKey]
        .filter(
          item =>
            !(item.status === "V" && (item.is_split === "N" || item.is_split === "Y"))
        )
        .map(item => item?.id)
    )
  }
  checked={
    (() => {
      const validItems = groupedData[groupKey].filter(
        item =>
          !(item.status === "V" && (item.is_split === "N" || item.is_split === "Y"))
      );
      return (
        validItems.length > 0 &&
        validItems.every(item => selectedRows.includes(item?.id))
      );
    })()
  }
  className={`w-4 h-4 cursor-pointer rounded form-checkbox transition-colors duration-200 ${
    (() => {
      const validItems = groupedData[groupKey].filter(
        item =>
          !(item.status === "V" && (item.is_split === "N" || item.is_split === "Y"))
      );
      return validItems.length > 0 &&
        validItems.every(item => selectedRows.includes(item?.id))
        ? "accent-[#900] border-[#900]"
        : "accent-gray-400 border-gray-400";
    })()
  }`}
/>
               <span className="text-sm">{`${filterby.name} - ${groupKey}`}</span>
             </div>
           </td>
           </tr>
              )}

              {groupedData[groupKey].map((item,index) => (
               <tr
               key={item.id}
               className={`border border-gray-300   ${
                 (item.status === 'S' && item.is_split === 'Y')||(item.status == "V" && (item.is_split=='Y'))||(item.status == "edit" && item.is_split=='Y')||(item.status === 'P' && item.is_split === 'Y')
                || item.status == "A" && (item.is_split=='Y')|| item.status == "D" && (item.is_split=='Y') ? 'bg-gray-200' : ''
               }`}
             >
              
                  <td className="p-3 relative ">
                  {(item.status === "S" || item.status === "A" || item.status === "P" ||item.status === "D" || item.status === "Edit") && item.is_split === "Y" ? (
 <div

 className=" w-full flex justify-center items-center">
 {/* Vertical line */}
 <div className={`absolute top-0 bottom-0 left-1/2 w-px bg-[#900] transform -translate-x-1/2 ${
      groupedData[groupKey][index + 1]?.emp_id === item.emp_id
        ? 'top-0 bottom-0' // Full vertical line
        : 'top-0 h-1/2' // Half vertical line (up to horizontal line)
    }`}></div>

 {/* Horizontal line from center going right */}
 <div className="absolute w-1/2 h-px bg-[#900] left-1/2 top-1/2"></div>
</div>
) : (item.status === "V" && (item.is_split === "N" || item.is_split === "Y")) ? (
  <></>
) : (
  <div className="flex justify-center items-center">
   <input
  type="checkbox"
  checked={selectedRows.includes(item.id)}
  onChange={() => {
    if (isProjectManager) return; // Prevent action
    handleRowSelect(item.id);
  }}
  disabled={isProjectManager}
  className={`w-4 h-4 rounded form-checkbox ${
    isProjectManager ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
  } ${
    selectedRows.includes(item.id)
      ? "accent-[#900] border-[#900]"
      : "appearance-none border-2 border-[#900]"
  }`}
/>
  </div>
)}


                  </td>
                  <td className="p-3">
                    <div className="flex items-center gap-2">
                     {item.status == "S" && (item.is_split=='Y')||item.status == "A" && (item.is_split=='Y')||(item.status === 'D' && item.is_split === 'Y')||(item.status === 'P' && item.is_split === 'Y')||(item.status === 'Edit' && item.is_split === 'Y')?
                     <>
                 <input
  type="checkbox"
  checked={selectedRows.includes(item.id)}
  onChange={() => {
    if (isProjectManager) return; // Prevent selection
    handleRowSelect(item.id);
  }}
  disabled={isProjectManager}
  className={`w-4 h-4 rounded form-checkbox ${
    isProjectManager ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
  } ${
    selectedRows.includes(item.id)
      ? "accent-[#900] border-[#900]"
      : "appearance-none border-2 border-[#900]"
  }`}
/>

                     </>:    !item.uu_id?.toLowerCase().startsWith("manualentry") &&
                     <img onClick={()=>{
                      setClickeditem(item)
                      setIspicModal(true)
                     }} src={human} alt="Employee" className="cursor-pointer" />}
                      <div className="whitespace-normal break-words text-start">
                          {item.uu_id?.toLowerCase().startsWith("manualentry") && (
  <span className="bg-[#8B1818] px-2 mb-1 py-1 rounded-full font-inter items-center text-white text-xs w-auto">
    {item.etype !== "EQP"?"Manual":"Equipment"} Entry
  </span>
)}
                        <div className="font-inter font-semibold text-start">
                          {item.emp_name}
                        </div> 
                         <div className="flex gap-2 text-sm text-[#6B7280]">
                          <div className="font-inter">{item.classification_name}</div>
                        </div>
                   <div className="flex gap-2 text-sm text-[#6B7280] items-center">
  <div className="font-inter">{item.emp_id}</div>
  {item?.row_info && (() => {
    try {
      const info = JSON.parse(item?.row_info);
      return info?.autoClockout === "Y" ? (
        <div className="px-[5px] py-[5px] text-[10px] text-center leading-none rounded-full bg-[#8B1818] text-white">
          Auto Clockout
        </div>
      ) : null;
    } catch {
      return null;
    }
  })()}
  {/* {item?.row_info && (() => {
  try {
    const info = JSON.parse(item?.row_info);
console.log(info,'info',item,'item')
  //  const hasAutoClockout = !(item.clockout_pic && item.clockin_pic) && (item.clockout_pic !== item.clockin_pic);
      
const hasAutoClockout =
  item.clockin_pic && item.clockout_pic && item.clockin_pic === item.clockout_pic;
    return hasAutoClockout ? (
      <div className="px-[5px] py-[5px] text-[10px] text-center leading-none rounded-full bg-[#8B1818] text-white">
        Auto Clockout
      </div>
    ) : null;

  } catch {
    return null;
  }
})()} */}
</div>

                      
                      </div>
                    </div>
                  </td>
                  <td className="p-3">
                    <div className="flex flex-col">
                    <div ref={suggestionRef}  className={`relative w-[96px] h-[28px] ${
    ((editedRows[item.id]?.costcodeDescription ?? item.costcodeDescription)?.trim() ||
     (editedRows[item.id]?.jobDescription ?? item.jobDescription)?.trim())
      ? 'mt-7'
      : ''
  }`}>
  <div className={`flex items-center justify-center w-full h-full border 
  ${errorfields.some(err => err.rowId === item.id && err.field === 'job_id') 
    ? 'border-red-500' 
    : 'border-[#E4E4E7]'} 
  bg-white rounded-[6px]`}>
    <input
      type="text"
      disabled={(item.status == "V" && (item.is_split=='N'))||(item.status == "I" && (item.is_split=='Y')||isProjectManager)}
      className="p-1 w-full h-full text-sm font-semibold rounded-[6px] focus:outline-none"
       value={editedRows[item.id]?.job_id ?? item.job_id}
    

      onFocus={() => setActiveRowId(item.id)}
      onChange={(e) => {
        handleEdit(item.id, "job_id", e.target.value);
        fetchSuggestions(e.target.value,item.id);
      }}
       onKeyDown={(e) => {
              if (e.key === 'Tab'&& showSuggestions && suggestions.length > 0 ) {
                e.preventDefault(); // Prevent default tab behavior
                const selectedCode = suggestions[0];
                handleSelect(selectedCode?.job_num); // Select the hovered item
                setActiveRowId(null); // Close the suggestions after selection
                handleEdit(item.id, 'job_id', selectedCode.job_num);
                handleEdit(item.id, 'jobDescription', selectedCode.job_name);
              }
            }}
    />
    
  </div>

  {/* Show dropdown only for the active row */}
  {activeRowId === item.id && showSuggestions && suggestions.length > 0 && (
     <ul className="absolute z-10 mt-1 left-0 text-start bg-white border border-gray-200 rounded-md shadow-lg max-h-[400px] overflow-y-auto text-sm w-auto min-w-[96px] whitespace-nowrap">
      {suggestions.map((code, index) => (
        <li
          key={index}
          onClick={() => {
                   handleSelect(code.job_num);
            setActiveRowId(null); // close suggestions after selection
            handleEdit(item.id, "job_id", code.job_num);
            handleEdit(item.id, "jobDescription", code.job_name);
          }}
          onMouseEnter={() => setHoveredIndex(index)} // Track hovered item
                className={`px-2 py-1 cursor-pointer hover:bg-gray-100 ${
                  hoveredIndex === index ? 'bg-gray-100' : ''
                }`}
        >
          {code.job_num} - {code.job_name}
        </li>
      ))}
    </ul>
  )}
                      </div>


<div className="text-xs font-inter text-start text-[#6B7280] break-words whitespace-normal line-clamp-2">
  {editedRows[item.id]?.jobDescription ?? item.jobDescription}
</div>
<div className="text-start text-red-500 text-sm">
  {errorfields.some(err => err.rowId === item.id && err.field === 'no_job_code')&&('Invalid Job Code')}
</div>
                    </div>
                  </td>
                  <td className="p-3  ">
                    <div className="flex flex-col ">
                    <div  className={`relative w-[96px] h-[28px] ${
    (editedRows[item.id]?.costcodeDescription ?? item.costcodeDescription) ? 'mt-[26px]' : ''
  }`}>
                    <div className={`flex items-center justify-center w-full h-full border 
  ${errorfields.some(err => err.rowId === item.id && err.field === 'cost_code_id') 
    ? 'border-red-500' 
    : 'border-[#E4E4E7]'} 
  bg-white rounded-[6px]`}>
                        <input
                          type="text"
                          className="p-1 w-full h-full text-sm font-semibold rounded-[6px] focus:outline-none"
                          value={
                            editedRows[item.id]?.cost_code_id ?? item.cost_code_id
                          }
         

                          disabled={(item.status == "V" && (item.is_split=='N')||(item.status == "I" && (item.is_split=='Y'))||isProjectManager)}
                          onFocus={() => setActiveRowId(item.id)}
                          onChange={(e) =>{
                            handleEdit(item.id, "cost_code_id", e.target.value)
                              fetchcostsSuggestions(e.target.value,item.id);

                          }}
                            onKeyDown={(e) => {
    if (
      e.key === "Tab" &&
      showcostSuggestions &&
      costs.length > 0 
    ) {
      e.preventDefault();
      const selected = costs[0];
      handleSelect(selected.cost_code);
      setActiveRowId(null);
      handleEdit(item.id, "cost_code_id", selected.cost_code);
      handleEdit(item.id, "costcodeDescription", selected.costcode_name);
      setcosts([]);
      setShowcostSuggestions(false);
    }
  }}
                        />
                      </div>
                      {activeRowId === item.id && showcostSuggestions && costs.length > 0 && (
     <ul className="absolute z-10 mt-1 left-0 text-start bg-white border border-gray-200 rounded-md shadow-lg max-h-[400px] overflow-y-auto text-sm w-auto min-w-[96px] whitespace-nowrap">
      {costs.map((code, index) => (
        <li
          key={index}
          onClick={() => {
            handleSelect(code.cost_code);
            setActiveRowId(null); // close suggestions after selection
            handleEdit(item.id, "cost_code_id", code.cost_code);
            handleEdit(item.id, "costcodeDescription", code.costcode_name);
            setcosts([])
            setShowcostSuggestions(false)
          }}
         onMouseEnter={() => setHoveredCostIndex(index)} // Track hovered
    className={`px-2 py-1 cursor-pointer hover:bg-gray-100 ${
      hoveredCostIndex === index ? "bg-gray-100" : ""
    }`}
        >
          {code.cost_code} - {code.costcode_name}
        </li>
      ))}
    </ul>
  )}
 </div>
                      <div className="text-xs font-inter text-start text-[#6B7280] break-words whitespace-normal line-clamp-2">
                        { editedRows[item.id]?.costcodeDescription ?? item.costcodeDescription}
                     
                       </div>
                       <div className="text-start text-red-500 text-sm">
  {errorfields.some(err => err.rowId === item.id && err.field === 'no_cost_code')&&('Invalid Cost Code')}
</div>
                    </div>
                  </td>
                  <td className="p-3 ">
                   { (item.status === 'S' && item.is_split === 'Y' )||(item.status === 'P' && item.is_split === 'Y')||(item.status === 'D' && item.is_split === 'Y')||item.status == "A" && (item.is_split=='Y')||(item.status === 'V' && item.is_split === 'Y' )||(item.etype === "EQP")||(item.status == "edit" && (item.is_split=='Y'))?<></>:
                   <div 
                   onClick={()=>console.log( editedRows[item.id]?.clock_in ??
                          (item.clock_in
                            ? item.clock_in                              
                                .substring(11, 16)
                            : ""))}
                   className={`flex items-center font-semibold justify-center w-full  border 
                    ${errorfields.find(err => err.rowId === item.id && err.field === 'clock_in') 
                      ? 'border-red-500' 
                      : 'border-[#E4E4E7]'} 
                    bg-white rounded-[6px]`}
                    
                    >
                      
                      {/* <input
                        type="time"
                        className="w-full p-1"
                        disabled={(item.status == "V" && (item.is_split=='N')||(item.status == "I" && (item.is_split=='Y'))||item.etype=='EQP')}
                        value={
                          editedRows[item.id]?.clock_in ??
                          (item.clock_in
                            ? item.clock_in                              
                                .substring(11, 16)
                            : "")
                        }
                        onChange={(e) =>{
                          handleEdit(item.id, "clock_in", e.target.value)
                          handleEdit(
                            item.id,
                            "hours",
                            calculateHours(
                              e.target.value,
                              editedRows[item.id]?.clock_out ??
                                (item.clock_out
                                  ? item.clock_out.split('T')[1].substring(0, 5)
                                  : ""),
                              editedRows[item.id]?.break_time ?? item.break_time,
                              item
                            )
                          );
                          

                          }  }
                      /> */}
                      {/* <TimePicker
  className="w-full text-sm  border border-gray-300 rounded"
  disableClock={true}
  clearIcon={null}
  clockIcon={null}
  format="hh:mm a"  // 12-hour format with AM/PM
  value={
    editedRows[item.id]?.clock_in ??
    (item.clock_in ? item.clock_in.substring(11, 16) : "")
  }
  onChange={(value) => {
    handleEdit(item.id, "clock_in", value);
    handleEdit(
      item.id,
      "hours",
      calculateHours(
        value,
        editedRows[item.id]?.clock_out ??
          (item.clock_out ? item.clock_out.split("T")[1].substring(0, 5) : ""),
        editedRows[item.id]?.break_time ?? item.break_time,
        item
      )
    );
  }}
  disabled={
    (item.status === "V" && item.is_split === "N") ||
    (item.status === "I" && item.is_split === "Y") ||
    item.etype === "EQP"
  }
/> */}




 <TimePicker
  format="hh:mm aa"
  showMeridiem
    cleanable={false}
     onBlur={()=>{
      
        if(!isValidClockTime(item,  editedRows[item.id]?.clock_in ??
        (item.clock_in ? item.clock_in.substring(11, 16) : ""),'clock_in')){
    setSeverity("error");
      setAlertMessage("clock out should be greater than clock in");
      setOpen(true);
      return
}
console.log('skipped clock out should be greater than clock in ')
    if(!check_is_valid_duration(item,item.emp_id,  editedRows[item.id]?.clock_in ??
        (item.clock_in ? item.clock_in.substring(11, 16) : ""),'clock_in')){
  setSeverity("error");
      setAlertMessage("Invalid total hours: The calculated total does not match the duration between clock-in and clock-out times.");
      setOpen(true);
      return
}
     }}
  value={
    (() => {
      const rawTime =
        editedRows[item.id]?.clock_in ??
        (item.clock_in ? item.clock_in.substring(11, 16) : "");

      // If time is valid, set it on today's date
      return rawTime
        ? dayjs().hour(Number(rawTime.split(":")[0])).minute(Number(rawTime.split(":")[1])).toDate()
        : null;
    })()
  }
  onChange={(value) => {
    // Assuming 'value' is a Date object; if it's a string, use dayjs(value).format('HH:mm')
    const formattedValue = dayjs(value).format('HH:mm'); // Ensure to format correctly
//         if(!isValidClockTime(item,formattedValue,'clock_in')){
//     setSeverity("error");
//       setAlertMessage("clock out should be greater than clock in");
//       setOpen(true);
//       return
// }
// console.log('skipped clock out should be greater than clock in ')
//     if(!check_is_valid_duration(item,item.emp_id,formattedValue,'clock_in')){
//   setSeverity("error");
//       setAlertMessage("Invalid total hours: The calculated total does not match the duration between clock-in and clock-out times.");
//       setOpen(true);
//       return
// }


    handleEdit(item.id, "clock_in", formattedValue);

    handleEdit(
      item.id,
      "hours",
      calculateHours(
        formattedValue,
        editedRows[item.id]?.clock_out ??
          (item.clock_out
            ? item.clock_out
            : ""),
        editedRows[item.id]?.break_time ?? item.break_time,
        item
      )
    );
  }}
  disabled={
    (item.status === "V" && item.is_split === "N") ||
    (item.status === "I" && item.is_split === "Y") ||
    item.etype === "EQP"||isProjectManager
  }
  size="sm"
/> 


                    </div>}
                  </td>

                  <td className="p-3">
                   { (item.status === 'S' && item.is_split === 'Y' )||(item.status === 'D' && item.is_split === 'Y')||(item.status === 'P' && item.is_split === 'Y')||item.status == "A" && (item.is_split=='Y')||(item.etype === "EQP")||(item.status === 'V' && item.is_split === 'Y' )||(item.status == "edit" && (item.is_split=='Y'))?<>
                   
                   </>:
                   
                   <div className={`flex font-semibold items-center justify-center  border 
  ${errorfields.find(err => err.rowId === item.id && err.field === 'clock_out') 
    ? 'border-red-500' 
    : 'border-[#E4E4E7]'} 
  bg-white rounded-[6px]`}>



<TimePicker
  format="hh:mm aa"
  showMeridiem
  cleanable={false}
     onBlur={()=>{
          if(!isValidClockTime(item, editedRows[item.id]?.clock_out ??
        (item.clock_out ? item.clock_out.substring(11, 16) : ""),'clock_out')){
    setSeverity("error");
      setAlertMessage("clock out should be greater than clock in");
      setOpen(true);
      return
}
if(!check_is_valid_duration(item,item.emp_id, editedRows[item.id]?.clock_out ??
        (item.clock_out ? item.clock_out.substring(11, 16) : ""),'clock_out')){
  setSeverity("error");
      setAlertMessage("Invalid total hours: The calculated total does not match the duration between clock-in and clock-out times.");
      setOpen(true);
      return
}

     }}
  value={
    (() => {
      const rawTime =
        editedRows[item.id]?.clock_out ??
        (item.clock_out ? item.clock_out.substring(11, 16) : "");

      return rawTime
        ? dayjs().hour(Number(rawTime.split(":")[0])).minute(Number(rawTime.split(":")[1])).toDate()
        : null;
    })()
  }
  onChange={(value) => {
    const formattedValue = dayjs(value).format('HH:mm');
//     if(!isValidClockTime(item,formattedValue,'clock_out')){
//     setSeverity("error");
//       setAlertMessage("clock out should be greater than clock in");
//       setOpen(true);
//       return
// }
// if(!check_is_valid_duration(item,item.emp_id,formattedValue,'clock_out')){
//   setSeverity("error");
//       setAlertMessage("Invalid total hours: The calculated total does not match the duration between clock-in and clock-out times.");
//       setOpen(true);
//       return
// }


    handleEdit(item.id, "clock_out", formattedValue);

    handleEdit(
      item.id,
      "hours",
      calculateHours(
        editedRows[item.id]?.clock_in ??
          (item.clock_in ? item.clock_in : ""),
        formattedValue,
        editedRows[item.id]?.break_time ?? item.break_time,
        item
      )
    );
  }}
  disabled={
    (item.status === "V" && item.is_split === "N") ||
    (item.status === "I" && item.is_split === "Y") ||
    item.etype === "EQP"||isProjectManager
  }
  className={`${
    errorfields.find(err => err.rowId === item.id && err.field === 'clock_out')
      ? 'border-red-500' 
      : 'border-[#E4E4E7]'
  }`}
   size="sm"
/>





                    </div>
                    }
                  </td>

                  <td className="p-3">
                { (item.status === 'S' && item.is_split === 'Y' )||(item.status === 'P' && item.is_split === 'Y')||(item.status === 'D' && item.is_split === 'Y')||item.status == "A" && (item.is_split=='Y')||(item.status === 'V' && item.is_split === 'Y' )||(item.etype === "EQP")||(item.status == "edit" && (item.is_split=='Y'))?<></>: <input
  type="text"
  inputMode="numeric"
  pattern="[0-9]*"
  disabled={(item.status == "V" && (item.is_split=='N')||(item.status == "I" && (item.is_split=='Y'))||isProjectManager)}
  className={`flex items-center font-semibold justify-center text-center max-w-[50px] h-[28px] border 
    ${errorfields.find(err => err.rowId === item.id && err.field === 'break_time') 
      ? 'border-red-500' 
      : 'border-[#E4E4E7]'} 
    bg-white rounded-[6px]`}
  
  value={editedRows[item.id]?.break_time ?? item.break_time}
  onChange={(e) => {
    const val = e.target.value;
    if (/^\d*$/.test(val)) {
//  const breakTime = val === '' ? '' : Number(val);

//     const rawTotalHours = editedRows[item.id]?.hours ?? item.hours;
//     const totalMinutes = typeof rawTotalHours === 'string'
//       ? timeStringToMinutes(rawTotalHours)
//       : rawTotalHours;

//     console.log(breakTime, totalMinutes, 'totttt');

//     if (breakTime !== '' && breakTime >= totalMinutes) {
//       setSeverity("error");
//       setAlertMessage("Break time cannot be greater than or equal to total hours.");
//       setOpen(true);
//       return;
//     }

      handleEdit(item.id, "break_time", val === '' ? '' : Number(val));
      
      handleEdit(item.id, "hours", calculateHours(
        editedRows[item.id]?.clock_in ??
          (item.clock_in
            ? item.clock_in
            : ""),
            editedRows[item.id]?.clock_out ??
            (item.clock_out
              ? item.clock_out
              : ""),
              val === '' ? '' : Number(val),
              item
      ))
    }
  }}
/>
              }

                  </td>
                  <td className="p-3 ">
                    {(item.etype === "EQP")?<></>:<input
                      type="text"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      disabled={(item.status == "V" && (item.is_split=='N')||(item.status == "I" && (item.is_split=='Y'))||isProjectManager)}
                      className={`flex items-center font-semibold justify-center text-center w-[56px] h-[28px] border 
                        ${errorfields.find(err => err.rowId === item.id && err.field === 'perdim') 
                          ? 'border-red-500' 
                          : 'border-[#E4E4E7]'} 
                        bg-white rounded-[6px]`}
                      
                      value={editedRows[item.id]?.perdim ?? item.perdim}
                    
                      onChange={(e) => {
                        const val = e.target.value;
                        if (/^\d*$/.test(val)) {
                          handleEdit(item.id, "perdim", val);
                        }
                      }}
                    />}
                  </td>
                  {/* <td className="p-3">
{item.status === 'S' && item.is_split === 'Y'||(item.status === 'P' && item.is_split === 'Y')||(item.status === 'D' && item.is_split === 'Y')||item.status == "A" && (item.is_split=='Y')||item.status === 'V' && item.is_split === 'Y'||(item.status == "edit" && (item.is_split=='Y'))?(
    <td className="p-3 text-center">
      <input
      type="text"
      inputMode="numeric"
      placeholder="HH:MM"
      ref={inputRef}
     onBlur={() => {
  let inputValue =
    editedRows[item.id]?.hours !== undefined
      ? editedRows[item.id].hours
      : item.hours?.slice(0, 5) || '';

  // Auto-correct the time format
  const [h, m] = inputValue.split(':');
  let hours = h?.padStart(2, '0') || '00';
  let minutes = m?.padStart(2, '0') || '00';

  const corrected = `${hours}:${minutes}`;

  handleEdit(item.id, 'hours', corrected);

  const isallow = getparent(item, corrected);

  if (!isallow) {
    setErrorFields([{ rowId: item.id, field: 'hours' }]);
    setSeverity("warning");
    setAlertMessage("Subtraction exceeds available time. Please check the entered value.");
    setOpen(true);
  }
}}
      disabled={
        (item.status === 'V' && item.is_split === 'Y') ||
        (item.status === "I" && item.is_split === 'Y') ||
        isProjectManager
      }
      value={
        editedRows[item.id]?.hours !== undefined
          ? editedRows[item.id].hours
          : item.hours?.slice(0, 5) || ''
      }
      onChange={(e) => {
        const input = inputRef.current;
        const selectionStart = input.selectionStart;

        let raw = e.target.value.replace(/[^0-9]/g, '');

        if (raw === '') {
          handleEdit(item.id, 'hours', '');
          return;
        }

        if (raw.length > 4) raw = raw.slice(0, 4);

        let formatted = raw;
        if (raw.length > 2) {
          formatted = `${raw.slice(0, 2)}:${raw.slice(2)}`;
        }
 getparent(
          item,
          editedRows[item.id]?.hours !== undefined
            ? editedRows[item.id].hours
            : item.hours?.slice(0, 5) || ''
        );
        handleEdit(item.id, 'hours', formatted);
        setErrorFields([]);

        // Delay to allow React to update, then reset cursor
        setTimeout(() => {
          if (inputRef.current) {
            let cursorPosition = selectionStart;
            if (raw.length === 3 && selectionStart === 3) cursorPosition += 1;
            if (formatted.length > 5) cursorPosition = 5;
            inputRef.current.setSelectionRange(cursorPosition, cursorPosition);
          }
        }, 0);
      }}
      pattern="^([01]\d|2[0-3]):([0-5]\d)$"
      className={`flex items-center justify-center font-semibold text-center w-[60px] h-[28px] border 
        ${
          errorfields.find(err => err.rowId === item.id && err.field === 'hours')
            ? 'border-red-500 focus:border-red-500'
            : 'border-[#E4E4E7]'
        } 
        bg-white rounded-[6px] 
        focus:outline-none focus:ring-0 focus:border-inherit 
      `}
    />
    </td>
  ) : (
    <td className="p-3 text-center">
      <div className="flex items-center justify-center w-[60px] font-semibold h-[28px] border border-[#E4E4E7] bg-white rounded-[6px]">
        {   editedRows[item.id]?.hours !== undefined
            ? editedRows[item.id].hours
            : item.hours?.slice(0, 5) || ''}
      </div>
    </td>
  )
}
                  </td> */}


<td className="p-3 text-center">
  {isDecimal ? (
    // ===== DECIMAL MODE =====
   <input
  type="number"
  step="0.01"
  placeholder="0.00"
  value={
    decimalInputs[item.id] !== undefined
      ? decimalInputs[item.id] // use raw typing
      : hhmmToDecimal(
          editedRows[item.id]?.hours !== undefined
            ? editedRows[item.id].hours
            : item.hours?.slice(0, 5) || ''
        )
  }
  onChange={(e) => {
    const val = e.target.value;
    setDecimalInputs((prev) => ({ ...prev, [item.id]: val })); 
    // ✅ only update local decimal string while typing
  }}
  onBlur={(e) => {
    const val = e.target.value;
    const hhmm = decimalToHHMM(val);

    // save back to your logic in HH:MM
    handleEdit(item.id, 'hours', hhmm);
    const isallow = getparent(item, hhmm);

    if (!isallow) {
      setErrorFields([{ rowId: item.id, field: 'hours' }]);
      setSeverity("warning");
      setAlertMessage(
        "Subtraction exceeds available time. Please check the entered value."
      );
      setOpen(true);
    }

    // cleanup raw input so next render uses hhmmToDecimal again
    setDecimalInputs((prev) => {
      const copy = { ...prev };
      delete copy[item.id];
      return copy;
    });
  }}
  disabled={
    (item.status === "V" && item.is_split === "Y") ||
    (item.status === "I" && item.is_split === "Y") ||
    isProjectManager
  }
  className={`flex items-center justify-center font-semibold text-center w-[60px] h-[28px] border 
    ${
      errorfields.find(
        (err) => err.rowId === item.id && err.field === "hours"
      )
        ? "border-red-500 focus:border-red-500"
        : "border-[#E4E4E7]"
    } 
    bg-white rounded-[6px] 
    focus:outline-none focus:ring-0 focus:border-inherit 
  `}
/>
  ) : 
 (<>
 {item.status === 'S' && item.is_split === 'Y'||(item.etype==='EQP')||(item.status === 'P' && item.is_split === 'Y')||(item.status === 'D' && item.is_split === 'Y')||item.status == "A" && (item.is_split=='Y')||item.status === 'V' && item.is_split === 'Y'||(item.status == "edit" && (item.is_split=='Y'))?(
    <td className="p-3 text-center">
      <input
      type="text"
      inputMode="numeric"
      placeholder="HH:MM"
      ref={inputRef}
     onBlur={() => {
  let inputValue =
    editedRows[item.id]?.hours !== undefined
      ? editedRows[item.id].hours
      : item.hours?.slice(0, 5) || '';

  // Auto-correct the time format
  const [h, m] = inputValue.split(':');
  let hours = h?.padStart(2, '0') || '00';
  let minutes = m?.padStart(2, '0') || '00';

  const corrected = `${hours}:${minutes}`;

  handleEdit(item.id, 'hours', corrected);
  if (item.etype !== 'EQP') {
  const isallow = getparent(item, corrected);

  if (!isallow) {
    setErrorFields([{ rowId: item.id, field: 'hours' }]);
    setSeverity("warning");
    setAlertMessage("Subtraction exceeds available time. Please check the entered value.");
    setOpen(true);
  }}
}


}
      disabled={
        (item.status === 'V' && item.is_split === 'Y') ||
        (item.status === "I" && item.is_split === 'Y') ||
        isProjectManager
      }
      value={
        editedRows[item.id]?.hours !== undefined
          ? editedRows[item.id].hours
          : item.hours?.slice(0, 5) || ''
      }
      onChange={(e) => {
        const input = inputRef.current;
        const selectionStart = input.selectionStart;

        let raw = e.target.value.replace(/[^0-9]/g, '');

        if (raw === '') {
          handleEdit(item.id, 'hours', '');
          return;
        }

        if (raw.length > 4) raw = raw.slice(0, 4);

        let formatted = raw;
        if (raw.length > 2) {
          formatted = `${raw.slice(0, 2)}:${raw.slice(2)}`;
        }
          if (item.etype !== 'EQP') {
 getparent(
          item,
          editedRows[item.id]?.hours !== undefined
            ? editedRows[item.id].hours
            : item.hours?.slice(0, 5) || ''
        )}
        handleEdit(item.id, 'hours', formatted);
        setErrorFields([]);

        // Delay to allow React to update, then reset cursor
        setTimeout(() => {
          if (inputRef.current) {
            let cursorPosition = selectionStart;
            if (raw.length === 3 && selectionStart === 3) cursorPosition += 1;
            if (formatted.length > 5) cursorPosition = 5;
            inputRef.current.setSelectionRange(cursorPosition, cursorPosition);
          }
        }, 0);
      }}
      pattern="^([01]\d|2[0-3]):([0-5]\d)$"
      className={`flex items-center justify-center font-semibold text-center w-[60px] h-[28px] border 
        ${
          errorfields.find(err => err.rowId === item.id && err.field === 'hours')
            ? 'border-red-500 focus:border-red-500'
            : 'border-[#E4E4E7]'
        } 
        bg-white rounded-[6px] 
        focus:outline-none focus:ring-0 focus:border-inherit 
      `}
    />
    </td>
  ) : (
    <td className="p-3 text-center">
      <div className="flex items-center justify-center w-[60px] font-semibold h-[28px] border border-[#E4E4E7] bg-white rounded-[6px]">
        {   editedRows[item.id]?.hours !== undefined
            ? editedRows[item.id].hours
            : item.hours?.slice(0, 5) || ''}
      </div>
    </td>
  )
}
 </>)
  }
</td>
                  <td className="p-3">
                    {item.is_split === 'Y' && ['S', 'A', 'P', 'D'].includes(item.status)? (
                      <div className="flex  items-start">
                       <div className="flex  flex-col items-center gap-3">
                      <div className="flex items-center gap-3">
                        <img
                          src={save}
                         onClick={!isProjectManager ? () => handleSave(item.id, item) : undefined}
                         className={`w-5 h-5 object-contain ${isProjectManager ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
                          alt="Save"
                        />
                      {item.etype == "EQP"?<></> : <img
                          src={fluent}
                          onClick={!isProjectManager ? () => handlesplitsave(item.id) : undefined}
                          className={`w-5 h-5 object-contain ${isProjectManager ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
                          alt="Fluent"
                        />}
                        <img
                         onClick={() => {
    if (isProjectManager) return; // Prevent function call
    setClickeditem(item);
    setDeletemodal(true);
  }}
                          src={delte}
                           className={`w-5 h-5 object-contain ${isProjectManager ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
                          alt="Delete"
                        />
                        
                      </div>
                                         {item?.status=='D' ? (
  <span className="bg-[#28A745] px-4 text-white rounded-full py-1 text-sm">
    Saved
  </span>):<></>}
                      </div ></div>
                    ) : (item.status == "P"||item.status == "D") && (item.is_split=='N') ?  <div className="flex  items-center gap-3">
                      <div className="flex flex-col gap-2 items-center">

    <div className="flex items-center justify-start gap-3">

                         <img
                      src={save}
                         onClick={!isProjectManager ? () => handleSave(item.id, item) : undefined}
                      className={`w-5 h-5 object-contain ${isProjectManager ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
                      alt="Save"
                    />
                    {item.etype == "EQP"?<></> : <img
                          onClick={!isProjectManager ? () => handlesplitsave(item.id) : undefined}
                      src={fluent}
                       className={`w-5 h-5 object-contain ${isProjectManager ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
                      alt="Fluent"
                    />  }
                     <img
                         onClick={() => {
    if (isProjectManager) return; // Prevent function call
    setClickeditem(item);
    setDeletemodal(true);
  }}
                          src={delte}
                          className={`w-5 h-5 object-contain ${isProjectManager ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
                          alt="Delete"
                        />
                      {item.clock_out && canResetClockout(item.clock_in) && (
  <div
    onClick={() => {
      setClearClockoutId(item.id);
      setClearClockoutModal(true);
    }}
  >
    <FontAwesomeIcon
      icon={faX}
      className="text-red-600 ml-1 cursor-pointer text-sm"
    />
  </div>
)}
                      </div>
                     {item?.status=='D' ? (
  <span className="bg-[#28A745] px-4 text-white rounded-full py-1 text-sm">
    Saved
  </span>
) : (
  <span className="bg-[#DC3545] px-4 text-white rounded-full py-1 text-sm">
    Pending
  </span>
)}

                      </div>
                  
                   
                  </div>: (item.status == "V" && (item.is_split=='N'))||(item.status == "V" && (item.is_split=='Y'))||(item.status == "D" && (item.is_split=='Y')) ? 
                     <div className="flex  items-center gap-3">

                    <div className="flex flex-col  items-center gap-3">
                 <FontAwesomeIcon
  icon={faPen}
  className={`${isProjectManager ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
  onClick={() => {
    if (isProjectManager) return; // disable click
    setClickeditem(item);
    setEditalert(true);
  }}
/>

                  <div className="bg-green-100 px-4 text-green-600  rounded-full py-1 text-sm truncate">
                         Submitted
                        </div>
                   
                  </div> </div>
             
                 :(item.is_split=='N'&&(item.status=='A'||item.status=='D'))?(
                

                  <div className="flex  items-center gap-3">
                         <div className="flex flex-col gap-2 items-center">
                         <div className="flex gap-3">
           <img
                          src={save}
                         onClick={!isProjectManager ? () => handleSave(item.id, item) : undefined}
 className={`w-5 h-5 object-contain ${isProjectManager ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}                          alt="Save"
                        />
                          {item.etype == "EQP"?<></> :<img
                  // onClick={()=>handlesplit(item.id)}
                          onClick={!isProjectManager ? () => handlesplitsave(item.id) : undefined}
                    src={fluent}
                  className={`w-5 h-5 object-contain ${isProjectManager ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
                    alt="Fluent"
                  /> }
                   <img
                         onClick={() => {
    if (isProjectManager) return; // Prevent function call
    setClickeditem(item);
    setDeletemodal(true);
  }}
                          src={delte}
                          className={`w-5 h-5 object-contain ${isProjectManager ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
                          alt="Delete"
                        />
                        {item.clock_out && canResetClockout(item.clock_in) && (
  <div
    onClick={() => {
      setClearClockoutId(item.id);
      setClearClockoutModal(true);
    }}
  >
    <FontAwesomeIcon
      icon={faX}
      className="text-red-600 ml-1 cursor-pointer text-sm"
    />
  </div>
)}

           </div>
                      
          {item?.status=='D'  ? (
  <span className="bg-[#28A745] px-4 text-white rounded-full py-1 text-sm">
    Saved
  </span>
) : (
  <span className="bg-[#DC3545] px-4 text-white rounded-full py-1 text-sm">
    Pending
  </span>
)}



                         </div>
          
                      </div>
                
                     
                    ):(item.status == "edit" && (item.is_split=='Y')) ? 
                    <div className="flex  items-start">
                       <div className="flex  flex-col items-center gap-3">
                    <div className="flex gap-3">

                       <img
                    src={save}
                         onClick={!isProjectManager ? () => handleSave(item.id, item) : undefined}
                     className={`w-5 h-5 object-contain ${isProjectManager ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
                    alt="Save"
                  />
                 {item.etype == "EQP"?<></>: <img
                          onClick={!isProjectManager ? () => handlesplitsave(item.id) : undefined}
                    src={fluent}
                   className={`w-5 h-5 object-contain ${isProjectManager ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
                    alt="Fluent"
                  />  }
                      <img
                        onClick={() => {
    if (isProjectManager) return; // Prevent function call
    setClickeditem(item);
    setDeletemodal(true);
  }}
                          src={delte}
                          className={`w-5 h-5 object-contain ${isProjectManager ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
                          alt="Delete"
                        />
                        {item.clock_out && canResetClockout(item.clock_in) && (
  <div
    onClick={() => {
      setClearClockoutId(item.id);
      setClearClockoutModal(true);
    }}
  >
    <FontAwesomeIcon
      icon={faX}
      className="text-red-600 ml-1 cursor-pointer text-sm"
    />
  </div>
)}
                    </div>
                    
                     
          {item?.status=='D'  ? (
  <span className="bg-[#28A745] px-4 text-white rounded-full py-1 text-sm">
    Saved
  </span>
) : (
  <span className="bg-[#DC3545] px-4 text-white rounded-full py-1 text-sm">
    Pending
  </span>
)}

                 
                </div> 
                    </div>
                   :(item.status == "I" && (item.is_split=='Y')||item.status == "I" && (item.is_split=='N')) ? 
            <div 
  className={`flex items-start ${isProjectManager ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`}
  onClick={() => {
    if (isProjectManager) return; // disable click
    setClickeditem(item);
    setRetrivemodal(true);
  }}
>
  <ReplayIcon />
</div>

                
                : <></>}
                  </td>
                </tr>
              ))}
            </React.Fragment>
          ))}
        </tbody>
      </table>

      {/* Pagination Controls */}
      <div className="flex justify-between items-center p-4 text-gray-700">
        {/* Left: Showing Entries */}
        <div className="flex items-center space-x-2">
          <span>
            Showing {(currentPage - 1) * entriesPerPage + 1}-
            {Math.min(currentPage * entriesPerPage, totalEntries)} of{" "}
            {totalEntries} entries
          </span>
          <select
            value={entriesPerPage}
            onChange={(e) => {
              setEntriesPerPage(parseInt(e.target.value));
              setCurrentPage(1);
            }}
            className="border cursor-pointer border-gray-300 p-1 rounded-md bg-white text-gray-700"
          >
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="20">20</option>
          </select>
          <span>per page</span>
        </div>

        {/* Right: Pagination */}
        <div className="flex flex-col items-center justify-center gap-4">
          <div className="flex items-center space-x-3">
            <button
              className="bg-white cursor-pointer font-sm text-[#000]"
              disabled={currentPage === 1}
              onClick={() => setCurrentPage(currentPage - 1)}
            >
              {"< Previous"}
            </button>
            <div>
              <span className="px-3 py-1 border text-[#000] border-gray-300 rounded-md">
                {currentPage}
              </span>
            </div>
            <button
              className="bg-white cursor-pointer text-[#000]"
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage(currentPage + 1)}
            >
              {"Next >"}
            </button>
          </div>
          <div  >
            Pages {currentPage} of {totalPages}
          </div>
        </div>
        <ClearClockoutModal
  open={clearClockoutModal}
  setOpen={setClearClockoutModal}
  onProceed={() => handleclearclockout(clearClockoutId)}
/>
        <Deletemodal ismodal={deleteemodal} setismodal={setDeletemodal} fun={handleDelete}/>
        <Retrivemodal ismodal={retrivemodal} setismodal={setRetrivemodal} fun={handleRetrive}/>
        <Editmodal ismodal={editalert} setismodal={setEditalert} fun={allowedit}/>
       {ispicmodal? <PicModal isoldbuild={isoldbuild} setClockinPicModal={setIspicModal} selectedItem ={clickeditem}/>:<></>}
      </div>
    </div>
  );
};

export default CrudTable;
